export default {
    // 缓存有效时间
    validTime: 1000 * 60 * 60 * 24 * 30,
    authCodeCd: 60,
}


// WEBPACK FOOTER //
// ./src/config.js